<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Pickings"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Unidade Origem</div>

        <lista-unidades-select
          v-model="filtros.unidadeOrigem"
        ></lista-unidades-select>
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Unidade Destino</div>

        <SelecaoUnidade
          :model="filtros.unidadeDestino"
          :resetar="reseteSelecaoUnidade"
          @enviarUnidade="receberUnidadeDestino"
        />
      </div>
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Status</div>
        <q-select
          dense
          outlined
          class="texto-titulo-input"
          v-model="filtros.status"
          :options="listaStatus"
          option-label="label"
        >
        </q-select>
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Data Inicial</div>
        <q-input
          v-model="filtros.dataInicial"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Data Final</div>
        <q-input
          v-model="filtros.dataFinal"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>

      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Numero Picking</div>
        <q-input
          dense
          class="texto-titulo-input"
          outlined
          v-model="filtros.numeroPicking"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
    </div>
    <div v-if="filtrosAtivos" class="flex items-center justify-end q-my-sm">
      <q-btn
        no-caps
        color="brand-1"
        label="Limpar Filtros"
        icon="refresh"
        @click="limparFiltros()"
      />
    </div>
    <div class="q-mt-xl">
      <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
        Pickings
      </div>
      <q-table
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        color="primary"
        dense
        row-key="id"
        :grid="mobile"
        flat
        v-model:pagination="pagination"
        no-data-label="Sem dados"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-12 col-md-6">
            <div class="row card">
              <div class="col-12">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span
                      ><strong>Origem:</strong>
                      {{ props.row.unidadeNomeOrigem }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Destino:</strong>
                      {{ props.row.unidadeNomeDestino }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Nº Picking:</strong> {{ props.row.numero }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Data de Criação:</strong>
                      {{
                        props.row?.dataCriacao
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}
                      {{ props.row?.dataCriacao.split(" ")[1] }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Criador:</strong>
                      {{
                        props.row.usuarioCriacao
                          ? `${props.row?.usuarioCriacao?.name} -`
                          : ""
                      }}{{
                        props.row.usuarioCriacao
                          ? ` ${props.row?.usuarioCriacao?.sap}`
                          : ""
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Colaborador:</strong>
                      {{
                        props.row.usuarioSolicitante
                          ? `${props.row?.usuarioSolicitante?.name} -`
                          : ""
                      }}{{
                        props.row.usuarioSolicitante
                          ? ` ${props.row?.usuarioSolicitante?.sap}`
                          : ""
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Contagem de Produtos:</strong>
                      {{ props.row?.itens?.length }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Status:</strong>
                      {{
                        `${props.row?.status
                          ?.charAt(0)
                          .toUpperCase()}${props.row?.status.substring(1)}`
                      }}
                    </span>
                  </div>
                </q-card-section>
              </div>
              <div class="col-12">
                <div class="text-brand-5 btn-grid-container">
                  <div class="row">
                    <div class="column col">
                      <q-btn
                        class="btn-grid-action"
                        stack
                        no-caps
                        :to="{
                          name:
                            props.row?.status == 'criado'
                              ? 'pkg-detalhe'
                              : 'pkg-detalhe-transferencia',
                          params: {
                            id:
                              props.row?.status == 'criado'
                                ? props.row?.pickingUuid
                                : props.row?.numero,
                          },
                        }"
                        label="Detalhe"
                        style="background: #3c76f1; color: white"
                        icon="article"
                      />
                    </div>
                    <div class="column col">
                      <q-btn
                        class="btn-grid-action"
                        stack
                        no-caps
                        label="Cancelar"
                        :disable="props.row.status != 'criado'"
                        :color="
                          props.row.status != 'criado' ? 'grey' : 'negative'
                        "
                        icon="close"
                        @click="
                          (confirmacao = !confirmacao),
                            (cancelarPickingId = props.row.pickingUuid)
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #body-cell-detalhe="props">
          <q-td :props="props">
            <q-btn
              icon="article"
              outline
              color="blue"
              round
              :to="{
                name:
                  props.row?.status == 'criado'
                    ? 'pkg-detalhe'
                    : 'pkg-detalhe-transferencia',
                params: {
                  id:
                    props.row?.status == 'criado'
                      ? props.row?.pickingUuid
                      : props.row?.numero,
                },
              }"
              flat
              type="a"
            />
          </q-td>
        </template>
        <template #body-cell-imprimir="props">
          <q-td :props="props">
            <q-btn
              icon="print"
              outline
              color="primary"
              round
              :to="{
                name: 'pkg-imprimir',
                params: {
                  id:
                    props.row?.status == 'criado'
                      ? props.row?.pickingUuid
                      : props.row?.numero,
                },
              }"
              flat
              type="a"
            />
          </q-td>
        </template>

        <template #body-cell-cancelar="props">
          <q-td :props="props">
            <q-btn
              icon="close"
              outline
              :color="props.row.status != 'criado' ? 'grey' : 'negative'"
              round
              :disable="props.row.status != 'criado'"
              flat
              @click="
                (confirmacao = !confirmacao),
                  (cancelarPickingId = props.row.pickingUuid)
              "
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md" v-if="rows?.length > 0">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
          :max-pages="6"
        />
      </div>
    </div>
    <dialog-confirm
      mensagem="Tem certeza que deseja cancelar esse Picking?"
      :exibir="confirmacao"
      :propsClass="'q-pa-md'"
      @resultado="resultado"
    >
    </dialog-confirm>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoUnidade from "../../ferramentaria/components/SelecaoUnidade.vue";
import { useQuasar } from "quasar";
import { useFilterPersistence } from "../../../composables/useFilterPersistence";
import DialogConfirm from "../components/DialogConfirm.vue";
import PageHeader from "../../../components/PageHeader.vue";
const columns = [
  {
    name: "unidadeNomeOrigem",
    label: "Origem",
    field: "unidadeNomeOrigem",
    align: "left",
    sortable: false,
  },
  {
    name: "unidadeNomeDestino",
    label: "Destino",
    field: "unidadeNomeDestino",
    align: "left",
    sortable: false,
  },
  {
    name: "numero",
    label: "Nº Picking",
    field: "numero",
    align: "left",
    sortable: false,
  },
  {
    name: "criador",
    label: "Criador",
    field: (row) => row?.usuarioCriacao?.name,
    align: "left",
    sortable: false,
  },

  {
    name: "criador",
    label: "Data de Criação",
    field: (row) =>
      row?.dataCriacao?.split(" ")[0].split("-").reverse().join("/") +
      " " +
      row?.dataCriacao?.split(" ")[1].split("-").reverse().join("/"),
    align: "left",
    sortable: false,
  },

  {
    name: "usuarioSolicitante",
    label: "Solicitante",
    field: (row) => row?.usuarioSolicitante?.name,
    align: "left",
    sortable: false,
  },
  {
    name: "contagem",
    label: "Contagem de Produtos",
    field: (row) =>
      row.itens && row.itens?.length != 0 ? row.itens?.length : "",
    align: "left",
    sortable: false,
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
    sortable: false,
  },
  {
    name: "imprimir",
    label: "Imprimir",
    field: "imprimir",
    align: "left",
    sortable: false,
  },
  {
    name: "detalhe",
    label: "Detalhe",
    field: "detalhe",
    align: "left",
    sortable: false,
  },
  {
    name: "cancelar",
    label: "Cancelar",
    field: "cancelar",
    align: "left",
    sortable: false,
  },
];

export default {
  components: {
    SelecaoUnidade,
    ListaUnidadesSelect,
    DialogConfirm,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const rows = ref([]);
    const filtros = ref({
      unidadeDestino: null,
      unidadeOrigem: "",
      dataInicial: "",
      dataFinal: "",
      status: null,
      numeroPicking: null,
    });

    const STORAGE_KEY = "picking-filtros";
    const {
      salvarFiltros,
      carregarFiltros,
      limparFiltros: limparFiltrosComposable,
    } = useFilterPersistence(STORAGE_KEY, filtros, {
      unidadeDestino: null,
      unidadeOrigem: "",
      dataInicial: "",
      dataFinal: "",
      status: null,
      numeroPicking: null,
    });

    const filtrosAtivos = computed(() => {
      const f = filtros.value;
      return (
        (f.unidadeDestino !== null &&
          Object.keys(f.unidadeDestino).length > 0) ||
        f.dataInicial !== "" ||
        f.dataFinal !== "" ||
        f.status !== null ||
        f.numeroPicking !== null
      );
    });

    const limparFiltros = () => {
      limparFiltrosComposable();
      // Resetar explicitamente todos os filtros
      filtros.value.unidadeDestino = null;
      filtros.value.dataInicial = "";
      filtros.value.dataFinal = "";
      filtros.value.status = null;
      filtros.value.numeroPicking = null;
      filtros.value.unidadeOrigem = "";
      if (store.state.org.unidadeData?.id) {
        filtros.value.unidadeOrigem = store.state.org.unidadeData;
      }
      reseteSelecaoUnidade.value++;
      pagination.value.page = 1;
      getDados();
    };

    const confirmacao = ref(false);
    const cancelarPickingId = ref(null);
    const isLoadingFilters = ref(false);
    const reseteSelecaoUnidade = ref(0);

    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const getDados = async (page = 1, rowsPerPage = 10) => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        let response = await store.dispatch("pkg/getListagemPickings", {
          page: page,
          perPage: rowsPerPage,
          unidadeIdOrigem: filtros.value.unidadeOrigem
            ? filtros.value.unidadeOrigem.id
            : undefined,
          unidadeIdDestino: filtros.value.unidadeDestino
            ? filtros.value.unidadeDestino.id
            : undefined,
          status: filtros.value.status,
          dataCriacao:
            filtros.value.dataInicial != ""
              ? filtros.value.dataInicial.split("/").reverse().join("-")
              : undefined,
          dataFinalizacao:
            filtros.value.dataFinal != ""
              ? filtros.value.dataFinal.split("/").reverse().join("-")
              : undefined,
          numero: filtros.value.numeroPicking,
        });

        rows.value = response.data.result.dados;
        pagination.value.rowsPerPage = response.data.result.perPage;
        pagination.value.rowsNumber = response.data.result.total;
        pagination.value.page = response.data.result.currentPage;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o listar picking",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(() => {
      isLoadingFilters.value = true;
      carregarFiltros();
      isLoadingFilters.value = false;
      getDados();
    });

    watch(
      () => filtros.value,
      () => {
        if (!isLoadingFilters.value) {
          salvarFiltros();
        }
      },
      { deep: true }
    );

    const receberUnidadeDestino = (value) => {
      if (value === null || value === "" || !value?.id) {
        filtros.value.unidadeDestino = null;
        return;
      }
      filtros.value.unidadeDestino = {
        nome: value.nome,
        id: value.id,
      };
    };

    const resultado = async (resposta) => {
      confirmacao.value = !confirmacao.value;
      if (resposta) {
        try {
          await store.dispatch("pkg/cancelarPicking", {
            id: cancelarPickingId.value,
          });

          quasar.notify({
            message: "Picking cancelado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          disable.value = false;
          getDados();
        } catch (error) {
          quasar.notify({
            message: "Erro a o cancelar picking",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidadeOrigem = store.state.org.unidadeData;
      }
    );
    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watchDebounced(
      [
        () => filtros.value.unidadeDestino,
        () => filtros.value.unidadeOrigem,
        () => filtros.value.dataInicial,
        () => filtros.value.dataFinal,
        () => filtros.value.status,
        () => filtros.value.numeroPicking,
      ],
      () => {
        if (isLoadingFilters.value) {
          return;
        }
        if (
          filtros.value.dataInicial != "" &&
          filtros.value.dataInicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.dataFinal != "" &&
          filtros.value.dataFinal.length != 10
        ) {
          return;
        }
        handleRequest();
      },
      { debounce: 400 }
    );

    return {
      filtros,
      pagination,
      disable,
      columns,

      handleRequest,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      listaStatus: ["criado", "separado", "em transito", "entregue"],
      receberUnidadeDestino,
      confirmacao,
      rows,
      resultado,
      cancelarPickingId,
      mobile,
      filtrosAtivos,
      limparFiltros,
      reseteSelecaoUnidade,
    };
  },
};
</script>

<style scoped>
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo {
  font-size: 20px;
}
.card {
  border: 1px solid #707070;
}
.text-grid-table {
  font-size: 19px;
}
@media (max-width: 1024px) {
  .texto-titulo-input {
    font-size: 14px;
  }
  .titulo-tabela {
    font-size: 20px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-grid {
    font-size: 19px;
  }
  .btn-grid-action {
    font-size: 16px;
    border-radius: 0px;
  }
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 17px;
  }
  .texto-titulo-input {
    font-size: 15px;
  }
  .titulo-tabela {
    font-size: 15px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-colunas {
    font-size: 10px;
  }
  .btn-grid {
    font-size: 15px;
  }
  .btn-grid-action {
    font-size: 12px;
    border-radius: 0px;
  }
  .text-grid-table {
    font-size: 15px;
  }
}
</style>
